import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished, loadingFailed, ConvertDatesToStrings } from "@itk/typescript-utils";
import { InvoiceLineGet, InvoiceLinesDialogState } from "./invoice-history-types";
import { Model_InvoiceLinePost, Model_InvoicePost, Model_PagedInvoiceGet } from "src/backend/openapi/v1";

export enum Action {
  GetInvoicesRequest = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:INVOICE-HISTORY:INVOICE-HISTORY-STORE.TS:ACTION:GETINVOICESREQUEST",
  GetInvoicesSuccess = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:INVOICE-HISTORY:INVOICE-HISTORY-STORE.TS:ACTION:GETINVOICESSUCCESS",
  GetInvoicesFail = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:INVOICE-HISTORY:INVOICE-HISTORY-STORE.TS:ACTION:GETINVOICESFAIL",

  GetInvoiceLinesRequest = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:INVOICE-HISTORY:INVOICE-HISTORY-STORE.TS:ACTION:GETINVOICELINESREQUEST",
  GetInvoiceLinesSuccess = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:INVOICE-HISTORY:INVOICE-HISTORY-STORE.TS:ACTION:GETINVOICELINESSUCCESS",
  GetInvoiceLinesFail = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:INVOICE-HISTORY:INVOICE-HISTORY-STORE.TS:ACTION:GETINVOICELINESFAIL",

  SetInvoiceLinesDialogState = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:INVOICE-HISTORY:INVOICE-HISTORY-STORE.TS:ACTION:SETINVOICELINESDIALOGSTATE",

  SetCreditNoteLinesDialogState = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:INVOICE-HISTORY:INVOICE-HISTORY-STORE.TS:ACTION:SETCREDITNOTELINESDIALOGSTATE",

  Clear = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:INVOICE-HISTORY:INVOICE-HISTORY-STORE.TS:ACTION:CLEAR"
}

type invoiceHistoryState = {
  invoicesState: Loading<Model_PagedInvoiceGet>;
  invoiceLinesState: Loading<InvoiceLineGet[]>;
  invoiceLinesDialogState?: InvoiceLinesDialogState;
  creditNoteLinesDialogState?: InvoiceLinesDialogState;
};

const initialState: invoiceHistoryState = {
  invoicesState: loadingNotStarted,
  invoiceLinesState: loadingNotStarted,
  invoiceLinesDialogState: undefined,
  creditNoteLinesDialogState: undefined
};

export const invoiceHistoryActions = {
  getInvoicesRequest: (customerId: string, data: ConvertDatesToStrings<Model_InvoicePost>, isCreditNote?: boolean) => actionCreator(Action.GetInvoicesRequest, { customerId, data, isCreditNote }),
  getInvoicesSuccess: (data: Model_PagedInvoiceGet) => actionCreator(Action.GetInvoicesSuccess, { data }),
  getInvoicesFail: () => actionCreator(Action.GetInvoicesFail),

  getInvoiceLinesRequest: (invoiceId: string, data: ConvertDatesToStrings<Model_InvoiceLinePost>) => actionCreator(Action.GetInvoiceLinesRequest, { invoiceId, data }),
  getInvoiceLinesSuccess: (data: InvoiceLineGet[]) => actionCreator(Action.GetInvoiceLinesSuccess, { data }),
  getInvoiceLinesFail: () => actionCreator(Action.GetInvoiceLinesFail),

  setInvoiceLinesDialog: (data?: InvoiceLinesDialogState) => actionCreator(Action.SetInvoiceLinesDialogState, data),

  setCreditNoteLinesDialog: (data?: InvoiceLinesDialogState) => actionCreator(Action.SetCreditNoteLinesDialogState, data),

  clear: () => actionCreator(Action.Clear)
};

export const invoiceHistoryReducer = (state = initialState, action: ActionReturnType<typeof invoiceHistoryActions>): invoiceHistoryState => {
  switch (action.type) {
    case Action.GetInvoicesRequest:
      return { ...state, invoicesState: loadingIsLoading };
    case Action.GetInvoicesSuccess:
      return { ...state, invoicesState: loadingFinished(action.payload.data) };
    case Action.GetInvoicesFail:
      return { ...state, invoicesState: loadingFailed };

    case Action.GetInvoiceLinesRequest:
      return { ...state, invoiceLinesState: loadingIsLoading };
    case Action.GetInvoiceLinesSuccess:
      return { ...state, invoiceLinesState: loadingFinished(action.payload.data) };
    case Action.GetInvoiceLinesFail:
      return { ...state, invoiceLinesState: loadingFailed };

    case Action.SetInvoiceLinesDialogState:
      return { ...state, invoiceLinesDialogState: action.payload };

    case Action.SetCreditNoteLinesDialogState:
      return { ...state, creditNoteLinesDialogState: action.payload };

    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
